import type React from "react";

import EditLevel from "./EditLevel";
import {useHotkeyManager} from "./hooks/useHotkeyManager";
import useLoadCurrentWipLevel from "./hooks/useLoadCurrentWipLevel";

const EditLevelWrapper: React.FC = () => {
  useHotkeyManager();
  useLoadCurrentWipLevel();

  return <EditLevel />;
};

export default EditLevelWrapper;
